// How this person can actually be reached, from followUps.reach (keyed by the
// Task's WhoId). An id that is ABSENT from the map means we did not find out —
// the reachability query is best-effort — and that is not the same as "no
// phone". Saying "email only" on a row we know nothing about would send a rep
// past a number that exists, so unknown says nothing at all.
export function reachOf(task, reach) {
  const row = task?.WhoId ? (reach || {})[task.WhoId] : null;
  if (!row) return { known: false, email: null, phone: null };
  return { known: true, email: row.email || null, phone: row.phone || null };
}

// Case.ContactId takes a Contact and nothing else, but Task.WhoId is
// polymorphic and may hold a Lead. The prefix is the only thing that tells
// them apart before Salesforce refuses the write.
export function contactIdOf(task) {
  const id = String(task?.WhoId || '');
  return id.startsWith('003') ? id : null;
}
